module.exports = __webpack_public_path__ + "img/section4Logo9.6f351694.svg";